// Currency ordering + flag emoji helpers.
// Popular list is fixed by product decision (Feb 2026, kullanıcı isteği):
//   1. TRY (Türk Lirası — home currency)
//   2. USD (global reserve)
//   3. AED (Körfez ticaret hattı)
//   4. EUR (AB pazarı)
//   5. GBP (Birleşik Krallık)
export const POPULAR_CURRENCIES = ['TRY', 'USD', 'AED', 'EUR', 'GBP'];

// Currency code → ISO 3166-1 alpha-2 country code (for flag emoji).
// Sadece yaygın olanlar; catalog dışındakiler için fallback boş string döner
// ve arayüz bayrağı gizler.
const CURRENCY_TO_COUNTRY = {
  TRY: 'TR', USD: 'US', EUR: 'EU', GBP: 'GB', AED: 'AE',
  JPY: 'JP', CHF: 'CH', CAD: 'CA', AUD: 'AU', NZD: 'NZ',
  CNY: 'CN', HKD: 'HK', SGD: 'SG', INR: 'IN', KRW: 'KR',
  RUB: 'RU', BRL: 'BR', ARS: 'AR', MXN: 'MX', ZAR: 'ZA',
  SAR: 'SA', QAR: 'QA', KWD: 'KW', BHD: 'BH', OMR: 'OM',
  EGP: 'EG', ILS: 'IL', SEK: 'SE', NOK: 'NO', DKK: 'DK',
  PLN: 'PL', CZK: 'CZ', HUF: 'HU', RON: 'RO', BGN: 'BG',
  UAH: 'UA', IDR: 'ID', THB: 'TH', MYR: 'MY', PHP: 'PH',
  VND: 'VN', PKR: 'PK', BDT: 'BD', NGN: 'NG', KES: 'KE',
  MAD: 'MA', DZD: 'DZ', TND: 'TN', COP: 'CO', CLP: 'CL',
  PEN: 'PE', UYU: 'UY',
};

// ISO2 country code → flag emoji (regional indicator symbols).
// "TR" → 🇹🇷. EU özel durum: gerçek EU bayrağı yerine unified emoji 🇪🇺.
const isoToFlag = (iso2) => {
  if (!iso2 || iso2.length !== 2) return '';
  if (iso2 === 'EU') return '🇪🇺';
  const A = 0x1F1E6; // Regional Indicator Symbol Letter A
  const first = iso2.charCodeAt(0) - 65 + A;
  const second = iso2.charCodeAt(1) - 65 + A;
  return String.fromCodePoint(first, second);
};

export const getCurrencyFlag = (currencyCode) => {
  const iso2 = CURRENCY_TO_COUNTRY[currencyCode?.toUpperCase?.()];
  return isoToFlag(iso2);
};

// Split a filtered currency list into { popular, rest } where popular follows
// the fixed POPULAR_CURRENCIES ordering and rest is alphabetical by code.
// Aynı listede iki grup arasında UI ince bir divider gösterir.
export const splitCurrenciesByPopularity = (currencies) => {
  const popularSet = new Set(POPULAR_CURRENCIES);
  const byCode = {};
  currencies.forEach((c) => {
    if (c?.code) byCode[c.code] = c;
  });
  const popular = POPULAR_CURRENCIES
    .map((code) => byCode[code])
    .filter(Boolean);
  const rest = currencies
    .filter((c) => c?.code && !popularSet.has(c.code))
    .sort((a, b) => (a.code || '').localeCompare(b.code || ''));
  return { popular, rest };
};
